import {routineForChildren, routineForComponent} from '@im-ng/route';

export const SOLUTIONS_SLUG = 'solutions';
export const SOLUTIONS_OVERVIEW_SLUG = 'smart-overview';
export const SOLUTIONS_FACTORY_SLUG = 'smart-factory';
export const SOLUTIONS_CITY_SLUG = 'smart-city';
export const SOLUTIONS_ENERGY_SLUG = 'smart-energy';
export const SOLUTIONS_SAFETY_SLUG = 'smart-safety';
export const SOLUTIONS_ENVIRONMENT_SLUG = 'smart-environment';


export const SOLUTIONS_OVERVIEW_ROUTINE = routineForComponent(
	'SOLUTIONS_OVERVIEW',
	[SOLUTIONS_SLUG, SOLUTIONS_OVERVIEW_SLUG],
	{
		// icon: 'menu24:ai-trained-model',
	}
);

export const SOLUTION_FACTORY_ROUTINE = routineForComponent(
	'SOLUTION_FACTORY',
	[SOLUTIONS_SLUG, SOLUTIONS_FACTORY_SLUG],
	{
		// icon: 'icon:smart-factory'
	}
);

export const SOLUTION_CITY_ROUTINE = routineForComponent(
	'SOLUTION_CITY',
	[SOLUTIONS_SLUG, SOLUTIONS_CITY_SLUG],
	{
		// icon: 'icon:smart-city'
	}
);

export const SOLUTION_ENERGY_ROUTINE = routineForComponent(
	'SOLUTION_ENERGY',
	[SOLUTIONS_SLUG, SOLUTIONS_ENERGY_SLUG],
	{
		// icon: 'icon:smart-energy'
	}
);

export const SOLUTION_SAFETY_ROUTINE = routineForComponent(
	'SOLUTION_SAFETY',
	[SOLUTIONS_SLUG, SOLUTIONS_SAFETY_SLUG],
	{
		// icon: 'icon:smart-safety'
	}
);

export const SOLUTION_ENVIRONMENT_ROUTINE = routineForComponent(
	'SOLUTION_ENVIRONMENT',
	[SOLUTIONS_SLUG, SOLUTIONS_ENVIRONMENT_SLUG],
	{
		// icon: 'icon:smart-environment'
	}
);


export const SOLUTION_ROUTINE = routineForChildren(
	'SOLUTIONS',
	[SOLUTIONS_SLUG],
	{
		// icon: 'icon:factory-management',
		children: [
			SOLUTIONS_OVERVIEW_ROUTINE.menu,
			SOLUTION_FACTORY_ROUTINE.menu,
			SOLUTION_CITY_ROUTINE.menu,
			SOLUTION_ENERGY_ROUTINE.menu,
			SOLUTION_SAFETY_ROUTINE.menu,
			SOLUTION_ENVIRONMENT_ROUTINE.menu
		]
	}
);


